if (!customElements.get('hg-mix-campaign')) {
  customElements.define('hg-mix-campaign', class extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;
      this.expiry = Date.parse(this.dataset.expires || '');
      this.listeners = new AbortController();
      this.link = this.querySelector('[data-mix-entry]');
      try { this.allowedVariants = new Set(JSON.parse(this.querySelector('[data-entry-variants]')?.textContent || '[]')); }
      catch (_) { this.allowedVariants = new Set(); }
      this.form = document.getElementById(this.dataset.formId || '');
      if (this.link) {
        this.link.addEventListener('click', () => this.updateLink(), { signal: this.listeners.signal });
        this.link.addEventListener('auxclick', () => this.updateLink(), { signal: this.listeners.signal });
        this.form?.addEventListener('change', () => this.updateLink(), { signal: this.listeners.signal });
        if (this.form) {
          this.variantObserver = new MutationObserver(() => this.updateLink());
          this.variantObserver.observe(this.form, { subtree: true, childList: true, attributes: true, attributeFilter: ['value', 'disabled'] });
        }
        this.updateLink();
      }
      this.setEndDate();
      if (this.updateCountdown()) this.interval = setInterval(() => this.updateCountdown(), 1000);
    }

    disconnectedCallback() {
      clearInterval(this.interval);
      this.variantObserver?.disconnect();
      this.listeners?.abort();
      this.initialized = false;
    }

    updateLink() {
      if (!this.link) return;
      const form = document.getElementById(this.dataset.formId || '');
      const id = form?.querySelector('input[name="id"]')?.value || '';
      const ready = form?.querySelector('[type="submit"]')?.disabled === false;
      const url = new URL(this.dataset.mixUrl, location.origin);
      const eligible = ready && this.allowedVariants.has(id);
      if (eligible) url.searchParams.set('mix_variant', id);
      this.link.href = `${url.pathname}${url.search}${url.hash}`;
      const label = eligible ? this.dataset.startLabel : this.dataset.browseLabel;
      this.link.replaceChildren(document.createTextNode(label || ''), this.arrow());
    }

    arrow() {
      const span = document.createElement('span');
      span.setAttribute('aria-hidden', 'true');
      span.textContent = '→';
      return span;
    }

    setEndDate() {
      if (!Number.isFinite(this.expiry)) return;
      const date = this.querySelector('[data-end-date]');
      if (!date) return;
      const locale = this.dataset.locale || 'de-DE';
      const day = new Intl.DateTimeFormat(locale, { timeZone: 'Europe/Berlin', day: '2-digit', month: '2-digit' }).format(this.expiry);
      const time = new Intl.DateTimeFormat(locale, { timeZone: 'Europe/Berlin', hour: '2-digit', minute: '2-digit', hourCycle: 'h23' }).format(this.expiry);
      date.textContent = `${day}, ${time}`;
    }

    updateCountdown() {
      const remaining = this.expiry - Date.now();
      if (!Number.isFinite(remaining) || remaining <= 0) {
        this.hidden = true;
        clearInterval(this.interval);
        if (Number.isFinite(remaining) && !this.expired) {
          this.expired = true;
          document.dispatchEvent(new CustomEvent('hg:mix-campaign-ended'));
        }
        return false;
      }
      this.hidden = false;
      const minutes = Math.ceil(remaining / 60000);
      const days = Math.floor(minutes / 1440);
      const hours = Math.floor((minutes % 1440) / 60);
      const parts = [];
      if (days) parts.push(`${days} ${this.dataset.daysLabel}`);
      if (days || hours) parts.push(`${hours} ${this.dataset.hoursLabel}`);
      parts.push(`${minutes % 60} ${this.dataset.minutesLabel}`);
      const value = parts.join(' · ');
      const output = this.querySelector('[data-time-left]');
      if (output && output.textContent !== value) output.textContent = value;
      const wrapper = this.querySelector('[data-time-wrapper]');
      if (wrapper) wrapper.hidden = false;
      return true;
    }
  });
}
